import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { tap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AdminGuard  {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const userLogged = JSON.parse(localStorage.getItem('userLogged'));
        const isSuperadmin = userLogged?.suiteRole === 'Superadmin';
        const isAllowedLocalRoute = route.data?.['allowLocal'] === true && environment.envType === 'local';

        if (!isSuperadmin && !isAllowedLocalRoute) {
            this.router.navigate(['/tax-suite'], { queryParams: { errorType: 'ForbiddenResource' }});
            return false
        } else {
            return true
        }
    }
}

@Injectable({ providedIn: 'root' })
export class FactoringGuard  {

    constructor(private router: Router, private authService: AuthService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const userLogged = JSON.parse(localStorage.getItem('userLogged'));

        const isSuperadmin = userLogged.suiteRole === "Superadmin";
        console.log(userLogged);
        this.authService.isUsersAllowedFactoring(userLogged.id).pipe(
            tap(user => {
                console.log(user);
                if (!user) {
                    if (isSuperadmin) return true
                    this.router.navigate(['/tax-suite'], {
                        queryParams: {
                            errorType: 'ForbiddenResource'
                        }
                    });
                }
            })
        ).subscribe();

        return true;
    }
}
